import { ErrorIllustration } from '@carboncopyco/illustrations';
import classNames from 'classnames';
import type React from 'react';
import { Spacer } from '../Spacer';

export interface ErrorBoxProps {
  title?: string;
  message?: string;
  illustration?: React.ReactNode;
  buttons?: React.ReactNode;
  contained?: boolean;
}

export const ErrorBox = ({
  title,
  message,
  illustration,
  buttons,
  contained,
}: ErrorBoxProps) => {
  return (
    <div
      className={classNames(
        'justify-center flex items-center bg-white w-full h-full',
        {
          'h-screen': !contained,
        }
      )}
    >
      <div className="relative flex flex-col justify-center items-center w-full h-full">
        <div className="flex w-full flex-col items-center text-center absolute justify-center">
          <div className="flex items-center justify-center w-full">
            {illustration || <ErrorIllustration />}
          </div>
          <div className="font-ds-bold w-full mt-8 text-ds-900 leading-ds-800 text-ds-natural-700">
            {title}
          </div>
          <div className="mt-2.5 text-ds-400 leading-ds-300 w-[400px] [text-wrap:balance] text-ds-natural-600">
            {message}
          </div>
          {buttons && <div className="flex mt-10">{buttons}</div>}
          <Spacer amount={3.3} />
        </div>
      </div>
    </div>
  );
};
